import 'jquery-serializejson';
const $ = jQuery;

class PageOoSearch {

    /**
     * Current page
     *
     * @type {Int}
     */
    current_page = 1;

    /**
     * Triggers all functionality initialization
     */
    docReady() {
        this.cache();
        this.events();
        this.loadUrlEvents();
    }

    /**
     * Class cache for DOM elements
     */
    cache() {

        this.cached = {};

        // Search form
        this.cached.$form      = $( '.search-area' );
        this.cached.$fieldsets = $( '.search-area fieldset' );

        // Search form selectors
        this.cached.$selectors = $( '.selector' );
        this.cached.$selectorToggles = $( '.selector__toggle' );
        this.cached.$selectorCloses  = $( '.selector__container__close' );

        // Search form checboxes and range selectors
        this.cached.$searchTermsCheckbox     = $( '.selector .checkbox-wrapper input' );
        this.cached.$searchTermsRangeSave    = $( '.selector--range .selector__container__close' );
        this.cached.$searchTermsToggleButton = $( '.toggle input' );

        // Search form checboxes and range selectors
        this.cached.$searchTermsCheckbox  = $( '.selector .checkbox-wrapper input' );
        this.cached.$searchTermsRangeSave = $( '.selector--range .selector__container__close' );

        // Search form price type hidden input
        this.cached.$priceTypeInput = $( 'input[name="price_type"]' );

        // Search form terms
        this.cached.$searchTermsList = $( '.search-terms__list' );
        this.cached.$searchTermEmpty = $( '.search-term--empty' );

        // Search results functionality
        this.cached.$searchResults    = $( '.search-results' );
        this.cached.$searchResultText = $( '.search-result-count' );
    }

    /**
     * Class events
     */
    events() {

        this.cached.$selectorToggles.on( 'click', ( e ) => this.toggleSelector( e ) );
        this.cached.$selectorCloses.on( 'click', ( e, doSearch ) => this.toggleSelector( e, doSearch ) );

        this.cached.$searchTermsCheckbox.on( 'change', ( e, doSearch ) => this.handleCheckbox( e, doSearch ) );
        this.cached.$searchTermsRangeSave.on( 'click', ( e, doSearch ) => this.handleRange( e, doSearch ) );
        this.cached.$searchTermsToggleButton.on( 'click', ( e ) => this.handleToggleButton( e ) );

        this.cached.$searchTermsList.on( 'click', 'li', ( e ) => this.handleTermClick( e ) );

        this.cached.$searchResults.on( 'click', '.paginate', ( e ) => this.handlePagination( e ) );
    }

    /**
     * Trigger js events for parameters in url
     */
    loadUrlEvents() {
        this.cached.$searchTermsCheckbox.trigger( 'change', false );
        this.cached.$searchTermsRangeSave.filter( ( i, el ) => {
            const priceType = $( el ).closest( 'fieldset' ).data( 'price-type' ) || false;
            return priceType === false || priceType === this.cached.$priceTypeInput.val();
        }).trigger( 'click', false );
    }

    /**
     * Toggles the dropdown selector state (open / closed).
     *
     * @param {Event} e        The click event from selector toggle / close buttons.
     * @param {bool}  doSearch Whether we should actually run the ajax search after this function, false when triggered from url parameters.
     */
    toggleSelector( e, doSearch = true ) {

        e.preventDefault();

        if( ! this.isFormEnabled() || ! doSearch ) {

            return;
        }

        // Find the clicked selector
        const $selector = $( e.target ).closest( '.selector' );

        // Make sure that all other selectors are closed
        this.cached.$selectors.not( $selector ).removeClass( 'active' );

        // Handle the clicked one
        $selector.toggleClass( 'active' );

        if( ! $selector.hasClass( 'active') ) {

            // Unbind the enter key
            this.toggleSelectorEvents( false );
        } else {

            // Bind enter key to the nearest close button
            const $closeBtn = $selector.find( '.selector__container__close' );
            const $shade    = $selector.find( '.selector__shade' );
            this.toggleSelectorEvents( true, $shade, $closeBtn );
        }
    }

    /**
     * When a selector is opened, bind 'enter' key to the nearest close button
     *
     * @param {Boolean} bind    Bind or unbind keypress.
     * @param {jQuery}  $shade  Activated selector's shader jQuery object.
     * @param {jQuery}  $button Activated button jQuery object.
     */
    toggleSelectorEvents( bind, $shade = null, $button = null ) {

        if( bind ) {

            $( document ).on( 'keyup', ( e ) => {

                if( e.which === 13 ) {

                    $button.click();
                    return false;
                }

                if( e.which === 27 ) {

                    $button.closest( '.selector' ).removeClass( 'active' );
                    return false;
                }
            });

            $shade.on( 'click', ( e ) => {
                $( e.target ).closest( '.selector' ).removeClass( 'active' );
                return false;
            });
        } else {
            $( document ).off( 'keyup' );
        }
    }

    /**
     * Handles the toggling of a checkbox
     *
     * @param {Event} e        The click event from a checkbox.
     * @param {bool}  doSearch Whether we should actually run the ajax search after this function, false when triggered from url parameters.
     */
    handleCheckbox( e, doSearch = true ) {

        if( ! this.isFormEnabled() ) {

            return;
        }

        const term = {
            'value': $( e.target ).val(),
            'name' : $( e.target ).attr( 'name' ),
            'text' : $( e.target ).next().text(),
            'type' : 'checkbox'
        };

        if ( $( e.target ).is( ':checked' ) ) {

            // Add the selected checkbox to search terms list
            this.addSearchTerm( [ term ] );
        }
        else {

            // Remove the selected checkbox from search terms list
            this.removeSearchTerm( term );
        }

        if ( doSearch ) {
            this.getSearchResults();
        }
    }

    /**
     * Handles the toggling of a toggle button
     *
     * @param {Event} e The click event from a toggle button.
     */
    handleToggleButton( e ) {

        if( ! this.isFormEnabled() ) {

            return;
        }

        const term = {
            'value': $( e.target ).val(),
            'name' : $( e.target ).attr( 'name' ),
            'text' : $( e.target ).next().text(),
            'type' : 'toggle'
        };

        // Reset pagination
        this.current_page = 1;

        this.getSearchResults();
    }

    /**
     * Handles the changing of range selector values
     *
     * @param {Event} e        The click event from an OK button.
     * @param {bool}  doSearch Whether we should actually run the ajax search after this function, false when triggered from url parameters.
     */
    handleRange( e, doSearch = true ) {

        if( ! this.isFormEnabled() ) {

            return;
        }

        // Parse values (min–max)
        const $inputs  = $( e.target ).closest( '.selector' ).find( 'input' );
        const valueMin = $( $inputs[0] ).val();
        const nameMin  = $( $inputs[0] ).attr( 'name' );
        const unitMin  = $( $inputs[0] ).data( 'unit' );
        const valueMax = $( $inputs[1] ).val();
        const nameMax  = $( $inputs[1] ).attr( 'name' );
        const unitMax  = $( $inputs[1] ).data( 'unit' );
        const type     = 'range';
        let textMin    = '';
        let textMax    = '';
        let textBoth   = '';

        // Handle the price range exception
        this.handlePriceRangeException( e );

        // Remove the range term if already set
        this.cached.$searchTermsList.find( 'input' ).filter( function() {

            return ( $( this ).attr('name') == nameMin || $( this ).attr('name') == nameMax );
        } ).parent( '.search-term' ).remove();

        // None set
        if ( valueMin === '' && valueMax === '' ) {

            this.removeSearchTerm();
        }
        // Only min
        else if ( valueMin !== '' && valueMax === '' ) {

            textMin = $( $inputs[0] ).prev().text() + ' ' + valueMin + ' ' + unitMin;

            const term = {
                'value': valueMin,
                'name' : nameMin,
                'text' : textMin,
                'type' : type
            };

            this.addSearchTerm( [ term ] );
        }
        // Only max
        else if ( valueMin === '' && valueMax !== '' ) {

            textMax  = $( $inputs[1] ).prev().text() + ' ' + valueMax + ' ' + unitMax;

            const term = {
                'value': valueMax,
                'name' : nameMax,
                'text' : textMax,
                'type' : type
            };

            this.addSearchTerm( [ term ] );
        }
        // Both
        else {

            textBoth  = valueMin + '–' + valueMax + ' ' + unitMax;

            const termMin = {
                'value': valueMin,
                'name' : nameMin,
                'text' : textBoth,
                'type' : type
            };
            const termMax = {
                'value': valueMax,
                'name' : nameMax,
                'text' : textBoth,
                'type' : type
            };

            this.addSearchTerm( [ termMin, termMax ] );
        }

        if ( doSearch ) {
            this.getSearchResults();
        }
    }

    /**
     * Handles the price range exception
     *
     * @param {Event} e The click event from an OK button.
     */
    handlePriceRangeException( e ) {

        const $selector  = $( e.target ).closest( '.selector' );
        const selectorId = '#' + $selector.attr( 'id' );

        // Bail early if not a price range selector
        if ( $selector.data( 'selector-type' ) !== 'price-range' ) {

            return false;
        }

        // If the price is already set on another price range selector, clear them
        $( '.selector[data-selector-type="price-range"]' ).not( selectorId ).find( 'input' ).val( '' );

        // Set the price type
        this.cached.$priceTypeInput.val( $selector.data( 'price-type' ) );
    }

    /**
     * Adds the search terms to the search term list
     *
     * @param {Array} terms The array of search terms (name, value, type) to be added.
     */
    addSearchTerm( terms ) {

        // Hide the "no terms" text
        if ( this.cached.$searchTermEmpty.is( ':visible' ) ) {

            this.cached.$searchTermEmpty.addClass( 'hidden' );
        }

        // Build the new terms
        const $termContainer = $( '<li class="search-terms__list__term search-term">' );
        const $iconContainer = $( '<i class="ion-close">' );
        let firstIteration   = true;
        let termText         = '';

        for ( var term of terms ) {

            // If the term is already there, bail early
            if ( this.cached.$searchTermsList.find( 'input[name="' + term.name + '"][value="' + term.value +'"]').length ) {

                return false;
            }

            // Add the text node only once in case of range selectors
            if ( firstIteration ) {

                termText = term.text || term.value;
                $termContainer.text( termText );
            }

            // Create the input with the correct attributes
            const $termInput     = $( '<input>' ).attr( {
                'type'     : 'hidden',
                'name'     : term.name,
                'value'    : term.value,
                'data-type': term.type
            } );

            // Append the new term input
            $termContainer.append( $termInput );

            // Set first iteration to false
            firstIteration = false;
        }

        $termContainer.prepend( $iconContainer );

        // Append the new term
        this.cached.$searchTermsList.append( $termContainer );

        // Reset pagination
        this.current_page = 1;
    }

    /**
     * Removes the clicked search term from the search term list
     *
     * @param {Object} term The search term object to be removed from the list.
     */
    removeSearchTerm( term = null ) {

        // If the term is set, remove it
        // This method can be called without a parameter just to clear the list
        if ( term ) {

            this.cached.$searchTermsList.find( 'input[name="' + term.name + '"][value="' + term.value +'"]').parent( '.search-term' ).remove();
        }

        // Show the "no terms" text if no terms are set
        if ( this.cached.$searchTermsList.find( 'li' ).length === 1 ) {

            this.cached.$searchTermEmpty.removeClass( 'hidden' );
        }

        // Reset pagination
        this.current_page = 1;
    }

    /**
     * Handles the inputs connected to the clicked search term
     *
     * @param {Event} e The click event.
     */
    handleTermClick( e ) {

        e.preventDefault();

        if( ! this.isFormEnabled() ) {

            return;
        }

        const $selectedTermInput = $( e.target ).find( 'input' );

        const value = $selectedTermInput.val();
        const name  = $selectedTermInput.attr( 'name' );
        const type  = $selectedTermInput.data( 'type' );
        const po    = $selectedTermInput.data( 'po' );

        const term = {
            'value': value,
            'name' : name
        };

        // Remove the term from the list
        this.removeSearchTerm( term );

        // Handle the search bar UI
        if ( type == 'checkbox' ) {

            // Find the input matching the clicked term and uncheck it
            $( 'input[name="' + name + '"][value="' + value + '"]' ).prop( 'checked', false );
        }
        else if ( type == 'range' ) {

            // Find the selector matching the clicked term and clear its inputs
            $( 'input[name="' + name + '"]' ).closest( '.selector' ).find( 'input' ).val( '' );
        }

        this.getSearchResults();
    }

    /**
     * Does the search by gathering the search arguments and passing them on
     * to the model. Then prints out the search results
     */
    getSearchResults() {

        // Get the search arguments
        let args = this.cached.$searchTermsList.find( 'input' ).serializeJSON();

        // Append toggle button arguments
        let toggleArgs = this.cached.$searchTermsToggleButton.serializeJSON();

        // Append price type argument
        let priceTypeArgs = this.cached.$priceTypeInput.serializeJSON();

        // Merge all args one array
        $.extend( args, toggleArgs, priceTypeArgs );

        // Toggle loader
        this.toggleLoader( true );

        // Append pagination data
        args.current_page = this.current_page;

        const newurl = new URL( window.location );
        newurl.search = new URLSearchParams( args );
        history.replaceState( {}, '', newurl.toString() );

        dp( 'PageOoSearch/SearchResults', {
            tidy: true,
            partial: 'oo-search-results',
            args: args,
            data: true,
            success: ( html, data ) => {

                const $data = $( html );

                // Replace current search results
                this.cached.$searchResults.children( '.dwelling-container' ).remove();
                this.cached.$searchResults.prepend( $data );

                // Handle result texts
                this.handleResultTexts( data.result_count );

                this.toggleLoader( false );
            },
        });
    }

    /**
     * Updates the result text after search
     *
     * @param {int} num Number of items matching the search.
     */
    handleResultTexts( num ) {

        // Init text vars
        const resultsPrependText = 'Hakuehdoillasi löytyi ';
        const resultsAppendText  = ' tulosta';
        const noResultsText      = 'Hakuehdoillasi ei löytynyt tällä hetkellä tuloksia';

        if ( num > 0 ) {

            this.cached.$searchResultText.html( resultsPrependText + "<span>" + num + "</span>" + resultsAppendText );
        } else {

            this.cached.$searchResultText.html( noResultsText );
        }
    }

    /**
     * Toggles the load indicator over the search results and disabled/enables the search form
     *
     * @param {Boolean} show Toggle the load indicator on (true) / off (false).
     */
    toggleLoader( show = true ) {

        if ( show ) {

            this.cached.$form.attr( 'disabled', 'disabled' );
            this.cached.$fieldsets.attr( 'disabled', 'disabled' );
            this.cached.$searchResults.addClass( 'loading' );
        } else {

            this.cached.$form.removeAttr( 'disabled' );
            this.cached.$fieldsets.removeAttr( 'disabled' );
            this.cached.$searchResults.removeClass( 'loading' );
        }
    }

    /**
     * Checks whether the search form is enabled or disabled
     *
     * @return {Boolean}
     */
    isFormEnabled() {

        if ( this.cached.$form.is( '[disabled=disabled]' ) ) {

            return false;
        }
        else {

            return true;
        }
    }

    /**
     * Changes the search result page
     *
     * @param {Event} e The click event.
     */
    handlePagination( e ) {

        e.preventDefault();
        const $target = $ ( e.target );

        if ( $target.parent( 'li' ).hasClass( 'unavailable' ) ) {

            return false;
        }

        $( 'html, body' ).animate( {

            scrollTop: this.cached.$searchResults.offset().top - 75
		}, 500) ;

        this.current_page = $target.data( 'page' );
        this.getSearchResults();
    }
}

export default PageOoSearch;



// WEBPACK FOOTER //
// ./assets/scripts/page-oo-search.js